import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  remove_session,
  faqCategoriesList,
  updateFaqCategory,
  deleteFaqCategoryPermanently,
  restoreFaqCategory,
  deleteFaqCategory,
  addFaqCategory,
} from "../../../functions/general";
import { toast } from "react-toastify";
import Media from "../../../components/Media";
import ModalImage from "react-modal-image";
import { usePermissions } from "../../../functions/usePermissions";

import { SortableContainer, SortableElement, SortableHandle, arrayMove } from "react-sortable-hoc";

const ListFAQCategories = (props) => {
  const { hasPermission } = usePermissions();

  const navigate = useNavigate();
  const [faqCategories, setFaqCategories] = React.useState([]);
  const [modalTitle, setModalTitle] = React.useState("");
  const [modalButtonText, setModalButtonText] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [image, setImage] = React.useState("");
  const [id, setId] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [tableDataLoading, setTableDataLoading] = React.useState(true);
  const [errors, setErrors] = React.useState("");
  useEffect(() => {
    props.setPageTitleAndSubTitle("FAQ Categories", "Here is the list of FAQ Categories !");
    fetchData();
  }, []);

  const fetchData = (type) => {
    faqCategoriesList().then((res) => {
      if (res && res.status == 200) {
        setFaqCategories(res?.data);
        setTableDataLoading(false);
        if (type === "add") {
          let sortedArray = [];
          res?.data?.map((faqCategory) => sortedArray.push(faqCategory?._id));
          faqCategoriesList(sortedArray).then((res) => {
            if (res && res.status == 200) {
              // fetchData();
            } else if (res && res.status == 401) {
              remove_session();
              props.getLoggedInUser();
              navigate("/login");
            } else {
              toast.error("Failed to sort the list.");
            }
            setTableDataLoading(false);
          });
        }
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
        setTableDataLoading(false);
      }
    });
  };

  const modalHandler = (category) => {
    if (category && category._id) {
      setModalTitle("Update FAQ Category");
      setModalButtonText("Update");
      setTitle(category?.title);
      setId(category._id);
    } else {
      setModalTitle("Add New FAQ Category");
      setModalButtonText("Add");
      setTitle("");
      setId("");
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (validate()) {
      setLoading(true);
      const category = {
        title: title,
      };
      let type = "add";
      if (id) {
        updateFaqCategory(id, category).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("FAQ Category updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update faq category.");
          }
          setLoading(false);
        });
      } else {
        addFaqCategory(category).then((res) => {
          if (res && res.status == 201) {
            fetchData(type);
            toast.success("FAQ Category added successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to add faq category.");
          }
          setLoading(false);
        });
      }
    }
  };

  const validate = () => {
    let errors = {
      title: "",
    };
    let isValid = true;
    if (!title) {
      isValid = false;
      errors.title = "Please enter title.";
    }
    setErrors(errors);
    return isValid;
  };

  const deleteHandler = (e, category) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete faq category?") == true) {
      if (window.confirm("Are you sure you want to delete faq category permanently?") == true) {
        deleteFaqCategoryPermanently(category._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Faq Category deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete category.");
          }
        });
      }
    }
  };

  const deleteStatusHandler = (e, category) => {
    e.preventDefault();
    let confirmText = "Are you sure you want to in-active the faq category?";
    if (category.isDeleted) {
      confirmText = "Are you sure you want to active the faq category?";
    }
    if (window.confirm(confirmText) == true) {
      if (category.isDeleted) {
        restoreFaqCategory(category._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("FAQ Category activated successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to active category.");
          }
        });
      } else {
        deleteFaqCategory(category._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("FAQ Category deactivated successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to inactive category.");
          }
        });
      }
    }
  };


  const onSortEnd = ({ oldIndex, newIndex }) => {
    setTableDataLoading(true);
    const faqCategories = arrayMove(faqCategories, oldIndex, newIndex);
    let sortedArray = [];
    faqCategories?.map((faqCategory) => sortedArray.push(faqCategory?._id));
    faqCategories(sortedArray).then((res) => {
      if (res && res.status == 200) {
        setFaqCategories(faqCategories);
        // fetchData();
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
        toast.error("Failed to sort the list.");
      }
      setTableDataLoading(false);
    });
  };

  const DragHandle = SortableHandle(() => (
    <div
      style={{
        cursor: "move",
        width: "20px",
        height: "20px",
      }}
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="grip-vertical"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      >
        <path
          fill="#6e6e6e"
          d="M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ></path>
      </svg>
    </div>
  ));

  const SortableTableRow = SortableElement(({ category, serialNo }) => {
    return (
      <tr style={{ width: "100%" }}>
        <td>{serialNo + 1}</td>
        {/* <td>
          <div className="maxWidth70px">
            <ModalImage small={process.env.REACT_APP_MEDIAPATH + category.image} large={process.env.REACT_APP_MEDIAPATH + category.image} />
          </div>
        </td> */}
        <td>{category.title}</td>
        {hasPermission("view-programs") && (
          <td>
            <Link to={`/faqs`} state={{ category }} className="btn btn-dark btn-xs">
              {category?.count ? category?.count : 0}
            </Link>
          </td>
        )}
        {hasPermission("edit-program-category") && (
          <td>
            <label className="switch">
              <input type="checkbox" checked={!category.isDeleted} onClick={(e) => deleteStatusHandler(e, category)} />
              <span className="slider round"></span>
            </label>
          </td>
        )}
        {(hasPermission("edit-program-category") || hasPermission("delete-program-category")) && (
          <td>
            <div className="d-flex">
              {hasPermission("edit-program-category") && (
                <button
                  data-toggle="modal"
                  data-target="#add"
                  onClick={(e) => modalHandler(category)}
                  className="btn btn-primary shadow btn-sm sharp mr-1"
                >
                  <i className="fa fa-pencil"></i>
                </button>
              )}
              {hasPermission("delete-program-category") && (
                <button onClick={(e) => deleteHandler(e, category)} className="btn btn-danger shadow btn-sm sharp">
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </div>
          </td>
        )}
        {/* {hasPermission("edit-program-category") && (
          <td>
            <DragHandle />
          </td>
        )} */}
      </tr>
    );
  });

  const SortableTable = SortableContainer(({ faqCategories }) => {
    return (
      <table id="roles-table" className="display dataTable" style={{ minWidth: "845px" }}>
        <thead>
          <tr>
            <th>No</th>
            {/* <th>Image</th> */}
            <th>Name</th>
            {hasPermission("view-programs") && <th>FQAs</th>}
            {hasPermission("edit-program-category") && <th>Status</th>}
            {(hasPermission("edit-program-category") || hasPermission("delete-program-category")) && <th>Actions</th>}
            {/* {hasPermission("edit-program-category") && <th>Sort Order</th>} */}
          </tr>
        </thead>
        <tbody>
          {tableDataLoading ? (
            <tr>
              <td colSpan="7" className="text-center pt-5">
                <div className="spinner-border text-black" role="status" aria-hidden="true"></div>
              </td>
            </tr>
          ) : (
            <>
              {faqCategories?.length > 0 ? (
                faqCategories?.map((category, index) => {
                  return <SortableTableRow key={index} category={category} index={index} serialNo={index} />;
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-center pt-5">
                    No faq category found!
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    );
  });

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-8">
            <ol class="breadcrumb bg-transparent mb-0" style={{ fontSize: "18px" }}>
              <li class="breadcrumb-item">
                <span onClick={() => navigate("/")}>
                  <i className="fas fa fa-home" style={{ fontSize: "28px", cursor: "pointer" }}></i>
                </span>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                FAQ Categories
              </li>
            </ol>
          </div>
          <div className="col-4">
            {hasPermission("add-program-category") && (
              <button className="btn btn-primary float-right" data-toggle="modal" data-target="#add" onClick={(e) => modalHandler()}>
                Add New
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <SortableTable faqCategories={faqCategories} onSortEnd={onSortEnd} useDragHandle={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="add">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header border-0 px-3 mb-3">
                <h5 className="modal-title">{modalTitle}</h5>
                <button type="button" className="close" data-dismiss="modal" id="categoryModalCloseButton">
                  <span>&times;</span>
                </button>
              </div>
              <form noValidate onSubmit={onSubmit}>
                <div className="form-group px-3">
                  <label>Title</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Program Category Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  {errors.title && !title && <div className="text-warning font-size-12 mt-2">{errors.title}</div>}
                </div>
                <div className="modal-footer border-0">
                  <button type="submit" className="btn btn-primary">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} {modalButtonText}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListFAQCategories;
